import axios from 'axios'
const baseApiUrl = 'https://educacional-pb.3eengenharia.com.br/api/'
// const baseApiUrl = 'http://educacional-2.0.local/api/'

axios.defaults.baseURL = baseApiUrl

function getAll (dateRange, tags) {
  const query = createQuery('events', {dateRange, tags})
  return axios.get(query)
      .then(res => res.data)
      .catch(err => err)
}

function createQuery (url, { dateRange, tags }) {
  if (dateRange) {
    url += `startDate=${dateRange[0]}&endDate=${dateRange[1]}`
  }
  if (tags && tags.length !== 0) {
    url += `&tags=`
    tags.forEach(tag => {
      url += `${tag},`
    })
  }
  return url
}

function getCountSpeeches ({dateRange, tags}) {
  console.log('speeches', dateRange, tags)
  return axios.post('speeches', { dateRange, tags })
    .then(res => res.data)
    .catch(err => err)
}

function getCountEvents ({dateRange, tags}) {
  console.log('events', dateRange, tags)
  return axios.post('events', {dateRange, tags})
    .then(res => res.data)
    .catch(err => err)
}

export function defineApiEduPost (tags, tagsObj) {
  let tagNames = {}
  for (let categorie in tags) {
    tagNames[categorie] = getTagsNameFromCategorie(tags[categorie], tagsObj)
  }
  return tagNames
}

const getTagsNameFromCategorie = function (tagsCategorie, tagsObj) {
  const tagNames = []
  for (let tagId of tagsCategorie) {
    const tagDoc = tagsObj.find(item => item._id === tagId)
    if (!tagDoc) continue
    tagNames.push(tagDoc.name)
  }
  return tagNames
}

export const apiEduService = {
  getAll,
  getCountSpeeches,
  getCountEvents
}



// WEBPACK FOOTER //
// ./src/services/ApiEducacional.js